import React from "react";
import { Link } from "react-router-dom";
import "./Impact.css";
import communityImg from "../../../images/community-health-outreach-kampala.jpeg";

const projects = [
  {
    icon: "people-outline",
    title: "Community Health Camps",
    text: "Free screenings, consultations, treatment, and health education bring care closer to people who need it most.",
  },
  {
    icon: "car-outline",
    title: "Transport Worker Health",
    text: "Our UTOF partnership supports taxi drivers with preventive care, practical health education, and medical follow-up.",
  },
  {
    icon: "megaphone-outline",
    title: "Health Awareness",
    text: "Radio, television, digital talks, and local events help families make informed choices about everyday health.",
  },
];

export default function Impact() {
  return (
    <section className="impact-section" aria-labelledby="impact-heading">
      <div className="container">
        <div className="impact-intro" data-aos="fade-up">
          <div className="impact-label"><ion-icon name="heart-outline"></ion-icon> Community Impact</div>
          <h2 id="impact-heading">Social Corporate Responsibility</h2>
          <p>Yitalife works with communities and partners to make quality healthcare more accessible, preventive, and practical across Uganda.</p>
        </div>

        <div className="row g-4 align-items-stretch">
          {/* Community image */}
          <div className="col-lg-4 col-md-12" data-aos="fade-right">
            <div className="impact-community-img-wrap">
              <img
                src={communityImg}
                alt="Yitalife community health outreach - free medical camp Kampala Uganda"
                className="impact-community-img"
              />
              <div className="impact-community-caption">
                Yitalife community outreach - bringing care to those who need it most
              </div>
            </div>
          </div>

          {/* Project cards */}
          <div className="col-lg-8">
            <div className="row g-4 h-100">
              {projects.map((project, index) => (
                <div className="col-md-12" key={project.title} data-aos="fade-up" data-aos-delay={index * 80}>
                  <article className="impact-project">
                    <div className="impact-icon"><ion-icon name={project.icon}></ion-icon></div>
                    <div>
                      <h3>{project.title}</h3>
                      <p>{project.text}</p>
                    </div>
                  </article>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="impact-action" data-aos="fade-up">
          <Link to="/Activity">Explore Our Community Work <ion-icon name="arrow-forward-outline"></ion-icon></Link>
        </div>
      </div>
    </section>
  );
}
